export default __webpack_public_path__ + "static/integraciones-73550db54f941cb4c869dd8331bf72af.png";